// extracted by mini-css-extract-plugin
export default {"panel":"CategoryPanel_panel__A+cXa","categoryContainer":"CategoryPanel_categoryContainer__rsClk","card":"CategoryPanel_card__KQxwH"};